import React from 'react';
import HomeNav from '../components/HomeNav';
import Footer from '../components/Footer';


const Contact = () => {
  return(
    <div id="body">
    <HomeNav />
    <section id="contact">

  <h1 className="section-header">Contact us</h1>

  <div className="contact-wrapper">


    <form id="contact-form" className="form-horizontal" role="form">

    <div className="form-group mb-3">
      <div className="col-sm-12">
        <input type="email" className="form-control" placeholder="Name" />
      </div>
    </div>

      <div className="form-group mb-3">
        <div className="col-sm-12">
          <input type="email" className="form-control"  placeholder="Email" />
        </div>
      </div>

      <textarea className="form-control" rows="10" placeholder="Message"></textarea>

      <button className="btn btn-primary send-button" id="submit" type="submit">
        <span>SEND MESSAGE</span>
      </button>

    </form>


      <div className="direct-contact-container">

        <ul className="contact-list">
          <li className="list-item"><i className="fa fa-map-marker fa-2x"><span className="contact-text place">Abuja, Nigeria</span></i></li>

          <li className="list-item"><i className="fa fa-phone fa-2x"><span className="contact-text phone"><a href="tel:+2347089386320" title="Call us">(+234) 708-938-6320</a></span></i></li>

          <li className="list-item"><i className="fa fa-envelope fa-2x"><span className="contact-text gmail"><a href="mailto:info@codefussion.tech" title="Send an email">info@codefussion.tech</a></span></i></li>

        </ul>

        <hr />
        <ul className="social-media-list">
          <li><a href="#" target="_blank" className="contact-icon">
            <i className="fab fa-github" aria-hidden="true"></i></a>
          </li>
          <li><a href="#" target="_blank" className="contact-icon">
            <i className="fab fa-codepen" aria-hidden="true"></i></a>
          </li>
          <li><a href="#" target="_blank" className="contact-icon">
            <i className="fab fa-twitter" aria-hidden="true"></i></a>
          </li>
          <li><a href="#" target="_blank" className="contact-icon">
            <i className="fab fa-instagram" aria-hidden="true"></i></a>
          </li>
        </ul>
        <hr />

      </div>

  </div>

</section>

    <Footer />
    </div>
  )
}

export default Contact
